<template>
  <span>
    <span v-if="comments.length > 0">
      <card shadow style="background-color:#eeeeff">
      <strong>{{ $t('comments') }}:</strong>
      <ul>
        <li
          v-for="aComment in comments" :key="aComment.id"
        >
        {{ aComment.comment }}
        </li>
      </ul>
      </card>
      <br/>            
    </span>
  </span>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  computed: {
    comments() {
      return this.$store.getters.getCommentsByCaseNumber(this.$store.getters.getCurrentCaseNumber);
    },    
  },
};
</script>
<i18n>
{
  "en": {
    "comments": "Comments from players (only shown to facilitators)"
  },
  "fi": {
    "comments": "Pelaajien kommentit (näkyy vain pelinjohtajalle)"
  },
  "sv": {
    "comments": "Spelarnas kommentarer (endast synlig för spelledare)"
  },
  "de": {
    "comments": "Kommentare von Spielern (werden nur den Spielmanager angezeigt)"
  },
  "ko": {
    "comments": "참여자 댓글 (퍼실리테이터에게만 공개)"

  }
}
</i18n>
